import React from 'react';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Space, Switch, Typography } from 'antd';
import styles from './BenefitCard.module.scss';

const { Text } = Typography;

const parseImg = (iconUrlJson?: string) => {
  if (!iconUrlJson) return '';
  try {
    const parsed = JSON.parse(iconUrlJson);
    return parsed?.tmUrl || parsed?.jdUrl || '';
  } catch (error) {
    return '';
  }
};

const BenefitCard = ({
  item,
  showDelete,
  allowView = true,
  allowEdit = true,
  allowSwitch = true,
  allowDelete = true,
  onView,
  onEdit,
  onToggleOpen,
  onToggleShow,
  onDelete,
}: any) => {
  const img = parseImg(item.iconUrlJson);
  const disableShowToggle = item?.basicBenefitsType === 'FIRST_CREATE_PET';
  const isOtherBenefit = item?.benefitsType === 'OTHER';
  const disableOpenToggle = isOtherBenefit;
  return (
    <div className={styles.card}>
      <div className={styles.top}>
        <div className={styles.thumb}>
          {img ? (
            <img
              className={styles.thumbImg}
              src={img}
              alt=""
            />
          ) : (
            <span className={styles.placeholder}>🖼️</span>
          )}
        </div>
        <div className={styles.info}>
          <div className={styles.titleRow}>
            <div className={styles.name}>{item.benefitsName || '--'}</div>
            <Space size={8}>
              {allowView && (
                <EyeOutlined
                  className={styles.iconAction}
                  onClick={() => onView?.(item)}
                />
              )}
              {isOtherBenefit && allowEdit && (
                <EditOutlined
                  className={styles.iconAction}
                  onClick={() => onEdit?.(item)}
                />
              )}
              {showDelete && allowDelete && (
                <DeleteOutlined
                  className={styles.deleteAction}
                  onClick={() => onDelete?.(item)}
                />
              )}
            </Space>
          </div>
          <div className={styles.desc}>{item.bListOverview || '暂无描述'}</div>
        </div>
      </div>
      <Space className={styles.statusRow}>
        {!disableOpenToggle && allowSwitch && (
          <div className={styles.statusItem}>
            <Text className={styles.statusLabel}>启用</Text>
            <Switch
              checked={item.openStatus === 0}
              onChange={checked => onToggleOpen?.(item, checked)}
            />
          </div>
        )}
        {!disableShowToggle && allowSwitch ? (
          <div className={styles.statusItem}>
            <Text className={styles.statusLabel}>显示</Text>
            <Switch
              checked={item.showStatus === 0}
              disabled={item.openStatus !== 0}
              onChange={checked => onToggleShow?.(item, checked)}
            />
          </div>
        ) : null}
      </Space>
    </div>
  );
};

export default BenefitCard;
